<template>
  <div class="modal fade" id="ChiefModal" tabindex="-1" aria-labelledby="ChiefModalLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="ChiefModalLabel" v-html="isLeader ? 'Руководитель' : 'Собственник'"></h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <template v-if="step === 0">
            <div class="border rounded pt-4 pb-4 mb-5">
              <div class="row">
                <div class="col-5">
                  <checkbox-field
                      v-model="data.filter.resident"
                      placeholder="Резидент"
                      id="data.filter.resident"
                      class="form-check-sm ms-5"
                  />
                </div>
                <div class="col-7">
                  <checkbox-field
                      v-model="data.client.politician"
                      placeholder="Публичное должностное лицо"
                      id="data.client.politician"
                      class="form-check-sm ms-5"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <input-mask-field
                    v-if="data.filter.resident"
                    v-model="data.client.iin"
                    id="data.client.iin"
                    name="data.client.iin"
                    :has-error="hasDoc"
                    :required="true"
                    :mb="5"
                    mask="############"
                    :placeholder="'ИИН'"
                    type="text"
                >
                  <div v-if="hasDoc" id="data.client.iin" class="invalid-feedback text-center opacity-75">
                    ИИН <b>{{ data.client.iin }}</b> уже указано.
                  </div>
                </input-mask-field>
                <input-field
                    v-else
                    v-model="data.document.number"
                    :has-error="hasDoc"
                    :required="true"
                    id="data.document.number"
                    name="data.document.number"
                    placeholder="Номер документа"
                    type="text"
                    mb="5"
                >
                  <div v-if="hasDoc" id="data.document.number" class="invalid-feedback text-center opacity-75">
                    Номер документа <b>{{ data.document.number }}</b> уже указано.
                  </div>
                </input-field>
              </div>
              <div class="col-6">
                <button @click="getChief" :disabled="(!data.client.iin && !data.document.number) || (data.client.iin && data.client.iin.length < 12)"
                        class="btn btn-light-primary btn-sm btn-block p-5 cursor-pointer">Поиск</button>
              </div>
            </div>
          </template>
          <template v-if="step === 1">
            <div class="client-card__panel border rounded">
              <i class="ki-duotone ki-security-user fs-3x"
                 :class="data.client.person ? 'text-primary' : 'text-warning'"
              >
                <i class="path1"></i>
                <i class="path2"></i>
              </i>
              <div class="ms-4">
                <div
                    class="fs-6 fw-bolder text-gray-700 line-clamp"
                    data-bs-toggle="tooltip" data-bs-placement="top"
                    :title="user.title">{{ user.title }}
                </div>
                <div class="fs-8 text-gray-400">
                  <span class="fs-8 text-gray-400">{{ data.client.iin ?? data.document.number }}</span> /
                  <span class="text-danger opacity-75">{{ data.filter.resident ? 'Резидент' : 'Нерезидент' }}</span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="step > 1">
            <div class="row">
              <div class="col-6" v-if="fieldSettings.iin.show">
                <input-mask-field
                    v-model="data.client.iin"
                    :required="fieldSettings.iin.required"
                    :disabled="fieldSettings.iin.disabled"
                    id="data.client.iin"
                    name="data.client.iin"
                    :mb="5"
                    placeholder="ИИН"
                    mask="############"
                    type="text"
                />
              </div>
              <div v-if="fieldSettings.phone.show" class="col-6">
                <input-mask-field
                    v-model="data.client.phone"
                    :required="fieldSettings.phone.required"
                    :disabled="fieldSettings.phone.disabled"
                    id="data.client.phone"
                    name="data.client.phone"
                    :mb="5"
                    placeholder="Сотовый номер"
                    mask="+7(###) ###-####"
                    type="text"
                />
              </div>
              <div v-if="fieldSettings.name.show" class="col-6">
                <input-field
                    v-model="data.client.name"
                    :required="fieldSettings.name.required"
                    :disabled="fieldSettings.name.disabled"
                    id="data.client.name"
                    name="data.client.name"
                    placeholder="Имя"
                    type="text"
                    mb="5"
                />
              </div>
              <div v-if="fieldSettings.surname.show" class="col-6">
                <input-field
                    v-model="data.client.surname"
                    :required="fieldSettings.surname.required"
                    :disabled="fieldSettings.surname.disabled"
                    id="data.client.surname"
                    name="data.client.surname"
                    placeholder="Фамилия"
                    type="text"
                    mb="5"
                />
              </div>
              <div v-if="fieldSettings.patronymic.show" class="col-6">
                <input-field
                    v-model="data.client.patronymic"
                    :required="fieldSettings.patronymic.required"
                    :disabled="fieldSettings.patronymic.disabled"
                    id="data.client.patronymic"
                    name="data.client.patronymic"
                    placeholder="Отчество"
                    type="text"
                    mb="5"
                />
              </div>
              <div v-if="fieldSettings.email.show" class="col-6">
                <input-field
                    v-model="data.client.email"
                    :required="fieldSettings.email.required"
                    :disabled="fieldSettings.email.disabled"
                    id="data.client.email"
                    name="data.client.email"
                    :placeholder="'Эл.почта'"
                    type="email"
                    mb="5"
                />
              </div>
              <div v-if="fieldSettings.birthday.show" class="col-6">
                <date-field
                    v-model="data.client.birthday"
                    :required="fieldSettings.birthday.required"
                    :disabled="fieldSettings.birthday.disabled"
                    id="client.birthday"
                    name="client_birthday"
                    placeholder="Дата рождения"
                    mb="5"
                />
              </div>
              <div v-if="fieldSettings.sex.show" class="col-6">
                <select-field
                    v-model="data.client.sex"
                    :required="fieldSettings.sex.required"
                    :disabled="fieldSettings.sex.disabled"
                    id="client.sex"
                    name="client_sex"
                    :options="{1:'Мужской', 2:'Женский'}"
                    placeholder="Пол"
                    mb="5"
                />
              </div>
            </div>
            <div v-if="fieldSettings.address.show" class="text-gray-700 fw-bold mb-3 ms-2">Адрес</div>
            <select-field
                v-if="fieldSettings.country_id.show"
                v-model="data.location.country_id"
                :required="fieldSettings.country_id.required"
                :disabled="fieldSettings.country_id.disabled"
                id="data.location.country_id"
                name="data.location.country_id"
                :options="this.countries"
                placeholder="Страна резиденства"
                mb="5"
            />
            <area-field
                v-if="fieldSettings.address.show"
                v-model="data.location.address"
                :required="fieldSettings.address.required"
                :disabled="fieldSettings.address.disabled"
                id="data.location.address"
                name="data.location.address"
                :class="'h-125px'"
                :placeholder="'Адрес'"
                mb="5"
            />
            <div v-if="fieldSettings.type_id.show" class="text-gray-700 fw-bold mb-3 ms-2">Документ</div>
            <div class="row">
              <div v-if="fieldSettings.type_id.show" class="col-12">
                <select-field
                    v-model="data.document.type_id"
                    :required="fieldSettings.type_id.required"
                    :disabled="fieldSettings.type_id.disabled"
                    id="data.document.type_id"
                    name="data.document.type_id"
                    :options="this.types"
                    placeholder="Вид документа"
                    mb="5"
                />
              </div>
              <div v-if="fieldSettings.number.show" class="col-6">
                <input-field
                    v-model="data.document.number"
                    :required="fieldSettings.number.required"
                    :disabled="fieldSettings.number.disabled"
                    id="data.document.number"
                    name="data.document.number"
                    placeholder="Номер документа"
                    type="text"
                    mb="5"
                />
              </div>
              <div v-if="fieldSettings.issued.show" class="col-6">
                <date-field
                    v-model="data.document.issued"
                    :required="fieldSettings.issued.required"
                    :disabled="fieldSettings.issued.disabled"
                    id="data.document.issued"
                    name="data.document.issued"
                    :placeholder="'Дата выдачи документа'"
                    mb="5"
                />
              </div>
              <div class="col-6" v-if="fieldSettings.issuer.show">
                <input-field
                    v-model="data.document.issuer"
                    :required="fieldSettings.issuer.required"
                    :disabled="fieldSettings.issuer.disabled"
                    id="data.document.issuer"
                    name="data.document.issuer"
                    placeholder="Кем выдано"
                    type="text"
                    mb="5"
                />
              </div>
              <div class="col-6" v-if="fieldSettings.until.show">
                <date-field
                    v-model="data.document.until"
                    :required="fieldSettings.until.required"
                    :disabled="fieldSettings.until.disabled"
                    id="data.document.until"
                    name="data.document.until"
                    placeholder="Дата завершения"
                    mb="5"
                />
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <div
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
              @click="clearForm"
          >Закрыть</div>
          <button
              :disabled="!valid"
              @click="addChief"
              type="submit"
              class="btn btn-sm btn-primary"
              v-html="'Добавить'">
          </button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
// Field
import InputMaskField       from '@/components/Fields/InputMaskField'
import CheckboxField        from '@/components/Fields/CheckboxField'
import SelectField          from '@/components/Fields/SelectField'
import InputField           from '@/components/Fields/InputField'
import DateField            from '@/components/Fields/DateField'
import AreaField            from '@/components/Fields/AreaField'
// Other
import ChiefModule from "@/helpers/Modules/Single/ChiefModule";
import LoaderFull  from '@/components/Main/LoaderFull'
import axios       from 'axios'

export default {
  name: 'ChiefModal',
  components: {InputMaskField, CheckboxField, SelectField, InputField, LoaderFull, AreaField, DateField},
  props: {
    isLeader: {
      type: Boolean,
      default: false
    },
    hash: {
      type: Number,
      default: null
    },
    chiefAddedList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: {
        client: {
          politician: false,
          iin:        null,
          surname:    null,
          name:       null,
          patronymic: null,
          birthday:   null,
          sex:        1,
          phone:      null,
          email:      null,
        },
        filter: {
          resident: true,
          person  : true,
          verify  : true,
        },
        document: {
          type_id:  1,
          number:   null,
          issued:   null,
          issuer:   null,
          until:    null
        },
        location: {
          country_id: null,
          address:    null
        }
      },
      user:           null,
      hasDoc:         false,
      step:           0,
      loader:         false,
      search:         false,
      countries:      null,
      fieldSettings:  null,
      valid:          false,
      types:          ChiefModule.documentType(1)
    }
  },
  mounted() {
    this.getCountries()
  },
  methods: {
    getCountries() {
      axios.get('/api/dictionaries/countries')
          .then(res => {
            this.countries = res.data
          })
    },
    getChief() {
      const checkDoc = this.chiefAddedList.indexOf(this.data.document.number) >= 0
      const checkIin = this.chiefAddedList.indexOf(this.data.client.iin) >= 0
      this.hasDoc = checkDoc || checkIin
      if (!this.hasDoc) {
        this.loader   = true
        const headers = {iin: this.data.client.iin, document: this.data.document.number}
        axios.post('/api/client/get-chief', headers)
            .then(res => {
              if (res.data.hasOwnProperty('id')) {
                this.step           = 1
                this.user           = res.data
                this.user['added']  = true
                this.valid          = true
              } else {
                this.$notifyError({message: 'Клиент не найден'})
                this.step = 2
              }
            })
            .catch(() => {
              this.$notifyError({message: 'Клиент не найден'})
            })
            .finally(() => this.loader = false)
      }
    },
    clearForm() {
      this.client = ChiefModule.empty()
      this.user   = null
      this.step   = 0
      this.loader = false
      this.search = false
      this.hasDoc = false
      this.valid  = false
    },
    addChief() {
      const doc = this.data.filter.resident ? this.data.client.iin : this.data.document.number
      if (this.step === 1) {
        this.user['added']  = true
        this.user['doc']    = doc
        this.$emit('addChief', {user:this.user})
      } else {
        this.loader = true
        let data    = structuredClone([this.data])
        axios.post('/api/client/set-chief', data)
            .then(res => {
              if (res.data && res.data.hasOwnProperty('id')) {
                this.step           = 1
                this.user           = res.data
                this.user['added']  = true
                this.user['doc']    = doc
                this.$emit('addChief', {user:this.user})
              } else {
                this.$notifyError(res.data)
              }
            })
            .catch(err => {
              this.$notifyError(err)
            })
            .finally(() => this.loader = false)
      }
    },
    flattenToValues(obj) {
      let result = {};
      for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          Object.assign(result, this.flattenToValues(obj[key]));
        } else {
          result[key] = obj[key];
        }
      }
      return result;
    },
    isValidObject(rules, data) {
      if (typeof rules !== 'object' || rules === null || typeof data !== 'object' || data === null) {
        return false;
      }

      return Object.entries(rules).every(([field, properties]) => {
        return !properties.required || !!data[field];
      });
    },
  },
  watch: {
    hash: {
      immediate: true,
      handler(val) {
        if (val) this.clearForm()
        let step = this.isLeader ? (this.data.filter.resident ? 4 : 5) : (this.data.filter.resident ? 6 : 7)
        this.fieldSettings = ChiefModule.fieldsSettings(step)
      }
    },
    data: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.valid = this.isValidObject(this.fieldSettings, this.flattenToValues(newValue))
      }
    },
    'data.filter.resident': {
      immediate: true,
      handler(val) {
        this.data.filter.verify = val
        if (this.step !== 2) {
          this.data.client.iin          = null
          this.data.document.number     = null
          this.data.location.country_id = val ? 1 : null
        }
        let step            = this.isLeader ? (val ? 4 : 5) : (val ? 6 : 7)
        this.fieldSettings  = ChiefModule.fieldsSettings(step)
      }
    },
    'data.client.iin': {
      immediate: true,
      handler() {
        if (this.step !== 2) {
          this.step     = 0
          this.hasDoc   = false
        }
      }
    },
    'data.document.number': {
      immediate: true,
      handler() {
        if (this.step !== 2) {
          this.step     = 0
          this.hasDoc   = false
        }
      }
    },
  }
}
</script>

<style scoped></style>
